(function() {
  const customIconHTML = `<span class="icon icon-garage inline-flex"><svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.5045 15.5537H20.7638V6.9129C20.7638 6.66911 20.7037 6.4291 20.5887 6.21414C20.4737 5.99918 20.3074 5.81592 20.1046 5.68062L11.9574 0.248776C11.7141 0.0865614 11.4282 0 11.1357 0C10.8433 0 10.5574 0.0865614 10.3141 0.248776L2.16682 5.68062C1.96386 5.81581 1.79741 5.99902 1.68226 6.21399C1.5671 6.42896 1.5068 6.66903 1.50671 6.9129V15.5537H0.766049C0.569614 15.5537 0.381225 15.6317 0.242324 15.7706C0.103424 15.9095 0.0253906 16.0979 0.0253906 16.2943C0.0253906 16.4908 0.103424 16.6792 0.242324 16.8181C0.381225 16.957 0.569614 17.035 0.766049 17.035H21.5045C21.7009 17.035 21.8893 16.957 22.0282 16.8181C22.1671 16.6792 22.2451 16.4908 22.2451 16.2943C22.2451 16.0979 22.1671 15.9095 22.0282 15.7706C21.8893 15.6317 21.7009 15.5537 21.5045 15.5537ZM2.98802 6.9129L11.1353 1.48106L19.2825 6.91197V15.5537H17.0605V10.369C17.0605 10.1726 16.9825 9.98419 16.8436 9.84529C16.7047 9.70639 16.5163 9.62835 16.3199 9.62835H5.95066C5.75422 9.62835 5.56583 9.70639 5.42693 9.84529C5.28803 9.98419 5.21 10.1726 5.21 10.369V15.5537H2.98802V6.9129ZM15.5792 11.1097V12.591H11.8759V11.1097H15.5792ZM10.3946 12.591H6.69132V11.1097H10.3946V12.591ZM6.69132 14.0723H10.3946V15.5537H6.69132V14.0723ZM11.8759 14.0723H15.5792V15.5537H11.8759V14.0723Z" fill="#262626"/>
  </svg></span>`;
  
  let isProcessing = false;
  
  function removeConvermaxIcon() {
    const garage = document.querySelector('#cm-garage');
    if (!garage) return;
    
    if (garage.hasAttribute('data-custom-processed')) return;
    
    isProcessing = true;
    
    garage.style.opacity = '0';
    garage.style.visibility = 'hidden';
    
    const toggleButton = garage.querySelector('.cm_toggle-dropdown, .garage-button, button, a');
    if (!toggleButton) return;
        (function gateForLogin() {
          const isCustomerLoggedIn = function() {
            try {
              const logoutBtn = document.querySelector('.btn-logout, a.btn-logout');
              if (logoutBtn) return true;
              const logoutLink = document.querySelector('a[href*="/account/logout"]');
              if (logoutLink) return true;
              const loginBtn = document.querySelector('.btn-login, a.btn-login');
              if (loginBtn) return false;
              const cls = (document.body && document.body.className) || '';
              if (/\bcustomer-logged-in\b/.test(cls)) return true;
              if (/\bcustomer-logged-out\b/.test(cls)) return false;
            } catch(_) {}
            return false;
          };

          if (toggleButton.__loginGateBound) return;

          const intercept = function(ev) {
            if (isCustomerLoggedIn()) return;
            try {
              ev.preventDefault();
              ev.stopImmediatePropagation();
            } catch (_) {}
            showLoginDropdown();
            return false;
          };

          toggleButton.addEventListener('click', intercept, true);
          
          toggleButton.addEventListener('keydown', function(e){
            const k = e.key || e.code;
            if (k === 'Enter' || k === ' ' || k === 'Spacebar' || k === 'Space') {
              intercept(e);
            }
          }, true);

          toggleButton.__loginGateBound = true;
        })();

        function showLoginDropdown() {
          const host = garage || document.body;
          const oldDiv = document.getElementById('garage-login-dropdown');
          if (oldDiv) try { oldDiv.remove(); } catch(_) {}

          let dd = document.getElementById('garage-login-details');
          if (!dd) {
            dd = document.createElement('details');
            dd.id = 'garage-login-details';
            dd.className = 'dropdown-component';
            dd.innerHTML = `
              <summary class="dropdown-summary" style="display:none"></summary>
              <div class="dropdown-layer dropdown-component-UI-color absolute">
                <div class="dropdown-inner relative">
                  <div class="dropdown-content">
                    <p class="dropdown-content-subtext">
                      <a class="underline" href="/account/login">Login</a><br>
                      <span>or</span><br>
                      <a class="underline" href="/account/register">create an account</a><br>
                      <span>to save your ride</span>
                    </p>
                  </div>
                </div>
              </div>`;
            host.appendChild(dd);

            const outside = (e) => {
              if (!dd.contains(e.target) && e.target !== toggleButton && !toggleButton.contains(e.target)) {
                dd.open = false;
                document.removeEventListener('mousedown', outside, true);
                document.removeEventListener('touchstart', outside, true);
                document.removeEventListener('keydown', onKey, true);
              }
            };
            const onKey = (e) => {
              if (e.key === 'Escape') {
                dd.open = false;
                document.removeEventListener('mousedown', outside, true);
                document.removeEventListener('touchstart', outside, true);
                document.removeEventListener('keydown', onKey, true);
              }
            };

            dd.__bindClose = function() {
              document.addEventListener('mousedown', outside, true);
              document.addEventListener('touchstart', outside, true);
              document.addEventListener('keydown', onKey, true);
            };
          }

          if (dd.open) {
            dd.open = false;
          } else {
            dd.open = true;
            dd.__bindClose && dd.__bindClose();
          }
        }
    
    // Style the toggle button for proper alignment
    toggleButton.style.display = 'flex';
    toggleButton.style.alignItems = 'center';
    toggleButton.style.gap = '6px';
    toggleButton.style.position = 'relative';
    
    // Remove ALL existing icons and icon containers from garage and toggle button
    const allIconContainers = garage.querySelectorAll('.garage-icon-container');
    allIconContainers.forEach(ic => ic.remove());
    
    const allGarageIcons = garage.querySelectorAll('.garage-icon, .cm_icon_garage__background, [class*="cm_icon"]');
    allGarageIcons.forEach(gi => gi.remove());
    
    const existingCustomIcons = garage.querySelectorAll('.icon-garage');
    existingCustomIcons.forEach(eci => eci.remove());
    
    const existingBadges = garage.querySelectorAll('.garage-size');
    existingBadges.forEach(badge => badge.remove());
    
    // Add custom icon only once
    if (toggleButton && !toggleButton.querySelector('.icon-garage')) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = customIconHTML;
      const iconElement = tempDiv.firstElementChild;
      toggleButton.insertBefore(iconElement, toggleButton.firstChild);
    }
    
    const garageLabel = garage.querySelector('.garage-label');
    if (garageLabel) {
      garageLabel.className = 'header-icon-text';
      garageLabel.textContent = 'My Garage';
    }
    
    const applyDialogStyles = function() {
      const dialog = document.querySelector('.dialog-container');
      if (dialog && !dialog.hasAttribute('data-styled')) {
        // Check if this is a YMM dialog (not filters)
        const hasYMMWidget = dialog.querySelector('.cm_vehicle-widget');
        const hasFilters = dialog.querySelector('.cm_FacetPanel');
        
        // Only apply black theme to YMM dialogs, skip filters
        if (hasFilters && !hasYMMWidget) {
          return; // Skip styling for filters dialog
        }
        
        dialog.setAttribute('data-styled', 'true');
        dialog.style.cssText = (dialog.style.cssText || '') + ';opacity: 0 !important; visibility: hidden !important;';

        if (!dialog.__visibilityGuard) {
          const guard = new MutationObserver(function() {
            if (!dialog.classList.contains('dialog-ready')) {
              dialog.style.opacity = '0';
              dialog.style.visibility = 'hidden';
            }
          });
          guard.observe(dialog, { attributes: true, attributeFilter: ['style', 'class'] });
          dialog.__visibilityGuard = guard;
        }

        setTimeout(function() {
          const allRows = dialog.querySelectorAll('.cm_row');
          allRows.forEach(row => {
            row.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          });
          
          const row = dialog.querySelector('.cm_vehicle-widget__row');
          if (row) row.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          dialog.style.cssText = 'background: #000000 !important; background-color: #000000 !important; border: 1px solid #ffffff !important; border-radius: 8px !important; padding: 20px !important;';
          
          const dialogContent = dialog.querySelector('.dialog-content');
          if (dialogContent) dialogContent.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          const dialogBody = dialog.querySelector('.dialog-body');
          if (dialogBody) dialogBody.style.cssText = 'background: #000000 !important; background-color: #000000 !important; color: #ffffff !important;';
          
          const widget = dialog.querySelector('.cm_vehicle-widget');
          if (widget) widget.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          const dropdowns = dialog.querySelector('.cm_vehicle-widget_dropdowns');
          if (dropdowns) dropdowns.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          const widgetBody = dialog.querySelector('.cm_vehicle-widget_body');
          if (widgetBody) widgetBody.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          const closeBtn = dialog.querySelector('.close');
          if (closeBtn) {
            closeBtn.style.cssText = 'position: absolute; top: 15px; right: 15px; color: #ffffff; cursor: pointer; z-index: 1000; background: #000000; padding: 5px; border-radius: 4px;';
            const closeSvg = closeBtn.querySelector('svg');
            if (closeSvg) closeSvg.style.stroke = '#ffffff';
          }
          
          const title = dialog.querySelector('.cm_vehicle-widget_title');
          if (title) title.style.color = '#ffffff';
          
          const goBtn = dialog.querySelector('.cm_vehicle-widget_button__go');
          if (goBtn) {
            goBtn.style.cssText = 'background: #da2625 !important; color: #ffffff !important; border: 1px solid #ffffff !important;';
          }
          
          const clearBtn = dialog.querySelector('.cm_vehicle-widget_button__clear');
          if (clearBtn) {
            clearBtn.style.cssText = 'background: #000000 !important; color: #ffffff !important; border: 1px solid #ffffff !important;';
            const clearSvg = clearBtn.querySelector('svg');
            if (clearSvg) clearSvg.style.fill = '#ffffff';
          }

          try {
            const wrappers = dialog.querySelectorAll('.cm_vehicle-widget_select, .cm_select');
            wrappers.forEach(w => {
              const label = w.querySelector('label, .cm_select_label, .cm_vehicle-widget_select-label');
              const text = (label ? label.textContent : w.textContent) || '';
              if (/sub\s*model/i.test(text)) {
                w.style.display = 'none';
              }
              const selects = w.querySelectorAll('select');
              selects.forEach(sel => {
                const id = sel.id || '';
                const name = sel.name || '';
                const cls = sel.className || '';
                if (/submodel|sub\-?model|submod/i.test(id + ' ' + name + ' ' + cls)) {
                  w.style.display = 'none';
                }
              });
            });
            const ordered = dialog.querySelectorAll('.cm_vehicle-widget_select');
            if (ordered && ordered.length >= 4) {
              const fourth = ordered[3];
              if (fourth) fourth.style.display = 'none';
            }
          } catch(e) {}
          
          if (dialog.__visibilityGuard) {
            dialog.__visibilityGuard.disconnect();
            dialog.__visibilityGuard = null;
          }
          dialog.classList.add('dialog-ready');
          const overlay = document.querySelector('.dialog-overlay');
          if (overlay) overlay.classList.add('dialog-ready');
          const backdrop = document.querySelector('.dialog-backdrop');
          if (backdrop) backdrop.classList.add('dialog-ready');
          
          const dialogCloseBtn = dialog.querySelector('.close');
          if (dialogCloseBtn && !dialogCloseBtn.__syncBound) {
            dialogCloseBtn.addEventListener('click', function() {
              setTimeout(syncConvermaxToYMM, 500);
            });
            dialogCloseBtn.__syncBound = true;
          }
        }, 30);
      }
    };
    
    const dialogObserver = new MutationObserver(function(mutations) {
      applyDialogStyles();
    });
    
    dialogObserver.observe(document.body, { childList: true, subtree: true });
    
    const syncConvermaxToYMM = function() {
      try {
        let year, make, model;
        
        const garageEl = document.querySelector('#cm-garage');
        if (garageEl) {
          const badge = garageEl.querySelector('.garage-size');
          const badgeText = badge ? badge.textContent.trim() : '';
          
          if (badgeText && badgeText !== '0') {
            const dropdown = garageEl.querySelector('.dropdown-content, .cm_dropdown-content');
            if (dropdown) {
              const items = dropdown.querySelectorAll('.garage-item, .cm_garage-item, [class*="vehicle"]');
              if (items.length > 0) {
                const firstItem = items[0];
                const text = firstItem.textContent || firstItem.innerText || '';
                const match = text.match(/(\d{4})\s+([^\s]+)\s+(.+)/);
                if (match) {
                  year = match[1];
                  make = match[2];
                  model = match[3].trim();
                }
              }
            }
          }
        }
        
        if (!year || !make || !model) {
          for (let key in localStorage) {
            if (key.includes('convermax') || key.includes('cm_') || key.includes('CMVehicle')) {
              try {
                const data = JSON.parse(localStorage.getItem(key));
                if (data && data.year && data.make && data.model) {
                  year = data.year;
                  make = data.make;
                  model = data.model;
                  break;
                }
              } catch(e) {}
            }
          }
        }
        
        if (!year || !make || !model) {
          const cookies = document.cookie.split(';');
          for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name.includes('cm_') || name.includes('convermax') || name.includes('vehicle')) {
              try {
                const data = JSON.parse(decodeURIComponent(value));
                if (data && data.year && data.make && data.model) {
                  year = data.year;
                  make = data.make;
                  model = data.model;
                  break;
                }
              } catch(e) {}
            }
          }
        }
        
        if (year && make && model) {
          const storage = {
            set: function(key, value, expiryDays = 1) {
              const expiry = expiryDays ? Date.now() + expiryDays * 24 * 60 * 60 * 1000 : null;
              const item = JSON.stringify({ value, expiry });
              localStorage.setItem(key, item);
            }
          };
          
          storage.set('ymm-year', year.toString());
          storage.set('ymm-make', make);
          storage.set('ymm-model', model);
          
          const event = new CustomEvent('ymmUpdated', { 
            detail: { year, make, model } 
          });
          document.dispatchEvent(event);
          
          return true;
        }
        return false;
      } catch(e) {
        return false;
      }
    };
    
    const cookieObserver = setInterval(syncConvermaxToYMM, 1000);
    syncConvermaxToYMM();
    
    garage.style.opacity = '1';
    garage.style.visibility = 'visible';
    garage.classList.add('garage-ready');
    
    garage.setAttribute('data-custom-processed', 'true');
    isProcessing = false;
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeConvermaxIcon);
  } else {
    removeConvermaxIcon();
  }
  
  const observer = new MutationObserver(function(mutations) {
    if (isProcessing) return;
    
    const garage = document.querySelector('#cm-garage');
    if (garage && !garage.hasAttribute('data-custom-processed')) {
      removeConvermaxIcon();
    }
  });
  
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();



// // Convert SKU to UPC for SET and WHEEL AND TIRE PACKAGE products
// (function() {
//   function convertSkuToUpc() {
//     const skuContainers = document.querySelectorAll('.cm_product-item__sku-container:not([data-processed])');
    
//     skuContainers.forEach(container => {
//       const skuTitle = container.querySelector('.sku-title');
//       const skuValue = container.querySelector('.sku-value');
      
//       if (!skuTitle || !skuValue) return;
      
//       container.setAttribute('data-processed', 'true');
      
//       const skuText = skuValue.textContent.trim();
      
//       if (skuText.startsWith('SET-')) {
//         skuTitle.textContent = 'UPC: ';
//         return;
//       }
      
//       const productItem = container.closest('.cm_product-item, .cm_product-item__details')?.parentElement;
//       const productTitle = productItem?.querySelector('.cm_product-item__title')?.textContent?.toLowerCase() || '';
      
//       const hasWheel = productTitle.includes('wheel');
//       const hasTire = productTitle.includes('tire');
      
//       if (hasWheel && hasTire) {
//         skuTitle.textContent = 'UPC: ';
//       } else if (hasTire && !hasWheel) {
//         container.style.display = 'none';
//       }
//     });
//   }
  
//   const observer = new MutationObserver(function(mutations) {
//     let hasNewSku = false;
//     for (let mutation of mutations) {
//       if (mutation.addedNodes.length) {
//         for (let node of mutation.addedNodes) {
//           if (node.nodeType === 1) {
//             if (node.classList?.contains('cm_product-item__sku-container') || 
//                 node.querySelector?.('.cm_product-item__sku-container')) {
//               hasNewSku = true;
//               break;
//             }
//           }
//         }
//       }
//       if (hasNewSku) break;
//     }
//     if (hasNewSku) convertSkuToUpc();
//   });
  
//   function startObserving() {
//     if (document.body) {
//       observer.observe(document.body, {
//         childList: true,
//         subtree: true
//       });
//       setTimeout(convertSkuToUpc, 500);
//       setTimeout(convertSkuToUpc, 1500);
//     }
//   }
  
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', startObserving);
//   } else {
//     startObserving();
//   }
// })();


// Replace SKU with UPC on collection pages only (not PDP)
(function() {
  // Only run on collection pages
  if (!window.location.pathname.startsWith('/collections/')) return;

  var productCache = {};

  function processProductCards() {
    var skuEls = document.querySelectorAll('.product-sku:not([data-upc-processed])');
    if (!skuEls.length) return;

    skuEls.forEach(function(skuEl) {
      skuEl.setAttribute('data-upc-processed', 'true');

      var card = skuEl.closest('.product-card') || skuEl.closest('.product-card-wrapper') || skuEl.parentElement;
      if (!card) { skuEl.style.display = 'none'; return; }

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) { skuEl.style.display = 'none'; return; }

      var href = link.getAttribute('href');
      var match = href.match(/\/products\/([^?#]+)/);
      if (!match) { skuEl.style.display = 'none'; return; }

      var handle = match[1];
      skuEl.style.visibility = 'hidden';

      function applyBarcode(data) {
        var barcode = '';
        if (data.variants && data.variants.length) {
          barcode = data.variants[0].barcode || '';
        }
        if (barcode && barcode.trim()) {
          skuEl.textContent = 'UPC: ' + barcode.trim();
          skuEl.style.visibility = 'visible';
        } else {
          skuEl.style.display = 'none';
        }
      }

      if (productCache[handle]) {
        applyBarcode(productCache[handle]);
        return;
      }

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          productCache[handle] = data;
          applyBarcode(data);
        })
        .catch(function() {
          skuEl.style.display = 'none';
        });
    });

    document.querySelectorAll('.cm_product-item__sku-container:not([data-processed])').forEach(function(c) {
      c.setAttribute('data-processed', 'true');
      c.style.display = 'none';
    });
  }

  var observer = new MutationObserver(function(mutations) {
    var hasNew = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1) {
            if ((node.classList && node.classList.contains('product-card')) ||
                (node.querySelector && node.querySelector('.product-sku'))) {
              hasNew = true;
              break;
            }
          }
        }
      }
      if (hasNew) break;
    }
    if (hasNew) processProductCards();
  });

  function startObserving() {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(processProductCards, 500);
      setTimeout(processProductCards, 1500);
      setTimeout(processProductCards, 3000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();

// Inject stock status (In Stock / Out of Stock) on Convermax product cards
(function() {
  var productCache = {};

  var ICON_INSTOCK = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.11111 0.388916C3.1842 0.388916 0 3.57311 0 7.50003C0 11.4269 3.1842 14.6111 7.11111 14.6111C11.038 14.6111 14.2222 11.4269 14.2222 7.50003C14.2222 3.57311 11.038 0.388916 7.11111 0.388916ZM10.961 6.96472L7.40543 10.5203C7.16049 10.7652 6.84049 10.8877 6.51852 10.8877C6.2242 10.8877 5.92988 10.785 5.69284 10.5776L3.32247 8.50348C2.80099 8.04719 2.74765 7.25509 3.20395 6.73361C3.66025 6.21213 4.45235 6.15879 4.97383 6.61509L6.46124 7.91682L9.18716 5.19089C9.67704 4.70101 10.4711 4.70101 10.961 5.19089C11.4509 5.68077 11.4509 6.47484 10.961 6.96472Z" fill="#19C98A"/></svg>';
  var ICON_OUTSTOCK = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.11C0 3.1837 3.1837 0 7.11 0C11.0363 0 14.22 3.1837 14.22 7.11C14.22 11.0363 11.0363 14.22 7.11 14.22C3.1837 14.22 0 11.0363 0 7.11ZM8.58721 7.10967L10.6294 5.06595L10.6312 5.06508C10.8272 4.86911 10.9373 4.60332 10.9373 4.32617C10.9373 4.04903 10.8272 3.78324 10.6312 3.58727C10.4352 3.3913 10.1693 3.28121 9.89217 3.28121C9.615 3.28121 9.34918 3.3913 9.15318 3.58727L7.10923 5.63186L5.06702 3.58814C4.87103 3.39217 4.60521 3.28208 4.32803 3.28208C4.05086 3.28208 3.78503 3.39217 3.58904 3.58814C3.39305 3.78411 3.28294 4.0499 3.28294 4.32704C3.28294 4.46427 3.30998 4.60015 3.3625 4.72693C3.41502 4.85372 3.492 4.96891 3.58904 5.06595L5.63126 7.10967L3.5873 9.15426C3.39131 9.35023 3.28121 9.61602 3.28121 9.89316C3.28121 10.1703 3.39131 10.4361 3.5873 10.6321C3.7833 10.828 4.04912 10.9381 4.32629 10.9381C4.60347 10.9381 4.86929 10.828 5.06528 10.6321L7.10923 8.58748L9.15405 10.6312C9.35005 10.8272 9.61587 10.9373 9.89304 10.9373C10.1702 10.9373 10.436 10.8272 10.632 10.6312C10.828 10.4352 10.9381 10.1694 10.9381 9.89229C10.9381 9.61515 10.828 9.34936 10.632 9.15339L8.58721 7.10967Z" fill="#F44336"/></svg>';

  function createStockLine(inStock) {
    var line = document.createElement('div');
    line.className = 'line-store-avaialble flex align-items-center';
    line.style.cssText = 'display:flex;align-items:center;gap:6px;margin-bottom:3px;font-size:13px;';
    var icon = document.createElement('span');
    icon.style.cssText = 'flex:0 0 15px;max-width:15px;line-height:0;';
    icon.innerHTML = inStock ? ICON_INSTOCK : ICON_OUTSTOCK;
    var text = document.createElement('span');
    text.textContent = inStock ? 'In Stock' : 'Out of Stock';
    line.appendChild(icon);
    line.appendChild(text);
    return line;
  }

  function applyStockStatus(card, data) {
    var detailsEl = card.querySelector('.cm_product-item__details, .product-info');
    if (!detailsEl) return;
    var titleEl = detailsEl.querySelector('.cm_product-item__title, .product-name');
    if (!titleEl) return;

    // Inject stock status after title
    var stockWrapper = document.createElement('div');
    stockWrapper.className = 'product-inventory cm-stock-status';
    stockWrapper.style.cssText = 'margin:6px 0 4px;';
    stockWrapper.appendChild(createStockLine(data.available));

    if (titleEl.nextSibling) {
      titleEl.parentNode.insertBefore(stockWrapper, titleEl.nextSibling);
    } else {
      titleEl.parentNode.appendChild(stockWrapper);
    }
  }

  function injectStockStatus() {
    var cards = document.querySelectorAll('.cm_product-item:not([data-stock-enriched]), .product-card:not([data-stock-enriched])');
    if (!cards.length) return;

    cards.forEach(function(card) {
      card.setAttribute('data-stock-enriched', 'true');
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      var match = href.match(/\/products\/([^?#]+)/);
      if (!match) return;
      var handle = match[1];

      if (productCache[handle]) {
        applyStockStatus(card, productCache[handle]);
        return;
      }

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          productCache[handle] = data;
          applyStockStatus(card, data);
        })
        .catch(function() {});
    });
  }

  var stockObserver = new MutationObserver(function(mutations) {
    var hasNewCards = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1 && (
            (node.classList && (node.classList.contains('cm_product-item') || node.classList.contains('product-card'))) ||
            (node.querySelector && (node.querySelector('.cm_product-item') || node.querySelector('.product-card')))
          )) {
            hasNewCards = true;
            break;
          }
        }
      }
      if (hasNewCards) break;
    }
    if (hasNewCards) injectStockStatus();
  });

  function startStockObserving() {
    if (document.body) {
      stockObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(injectStockStatus, 500);
      setTimeout(injectStockStatus, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startStockObserving);
  } else {
    startStockObserving();
  }
})();

// Hide Affirm financing on Convermax product results
(function() {
  function hideAffirm() {
    const affirmElements = document.querySelectorAll('.cm_product-item .affirm-as-low-as, .cm_results-products .affirm-as-low-as, [class*="cm_product"] .affirm-as-low-as');
    affirmElements.forEach(el => {
      el.style.display = 'none';
    });
  }
  
  const affirmObserver = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.querySelector?.('.affirm-as-low-as')) {
            hideAffirm();
            break;
          }
        }
      }
    }
  });
  
  function startAffirmHiding() {
    if (document.body) {
      affirmObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
      setTimeout(hideAffirm, 500);
      setTimeout(hideAffirm, 1500);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAffirmHiding);
  } else {
    startAffirmHiding();
  }
})();
/**
 * Convermax Filter +/- Icon Toggle
 * Replaces arrow icons with +/- symbols that change on expand/collapse
 */

(function() {
  'use strict';

  // --- Facet collapse/expand state management ---
  // CSS in convermax-custom.css collapses all facet bodies by default.
  // We track which facets the user has manually opened via the openFacets Set.
  // After Convermax re-renders (filter selection), we re-apply the state.

  const openFacets = new Set();

  function getFacetFieldId(facetholder) {
    const match = facetholder.className.match(/cm_field-[\w-]+/);
    return match ? match[0] : null;
  }

  function applyFacetState() {
    const holders = document.querySelectorAll('.cm_Facets .facetholder, .cm_FacetPanel .facetholder');
    holders.forEach(function(holder) {
      const fieldId = getFacetFieldId(holder);
      if (!fieldId) return;
      if (openFacets.has(fieldId)) {
        holder.classList.add('cm-filter-open');
      } else {
        holder.classList.remove('cm-filter-open');
      }
    });
    updateFilterIcons();
  }

  function updateFilterIcons() {
    const filterHolders = document.querySelectorAll('.cm_Facets .facetholder, .cm_FacetPanel .facetholder');

    filterHolders.forEach(function(holder) {
      const title = holder.querySelector('.facettitle');
      const body = holder.querySelector('.facetbody');

      if (!title || !body) return;

      // Hide Convermax default SVG icons
      const allSvgs = title.querySelectorAll('svg');
      allSvgs.forEach(function(svg) {
        svg.style.display = 'none';
        svg.style.visibility = 'hidden';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.position = 'absolute';
        svg.style.left = '-9999px';
      });

      const filterTitle = title.textContent.trim();
      if (filterTitle.toLowerCase().includes('shop') && filterTitle.toLowerCase().includes('wheel')) {
        return;
      }

      let iconSpan = title.querySelector('.filter-toggle-icon');
      if (!iconSpan) {
        iconSpan = document.createElement('span');
        iconSpan.className = 'filter-toggle-icon';
        iconSpan.style.width = '12px';
        iconSpan.style.height = '2px';
        iconSpan.style.backgroundColor = 'rgba(112, 112, 112, 1)';
        iconSpan.style.display = 'block';
        iconSpan.style.position = 'relative';
        iconSpan.style.marginLeft = 'auto';
        iconSpan.style.flexShrink = '0';
        title.appendChild(iconSpan);

        title.style.display = 'flex';
        title.style.alignItems = 'center';
        title.style.justifyContent = 'space-between';
      }

      const isCollapsed = !holder.classList.contains('cm-filter-open');

      iconSpan.innerHTML = '';
      iconSpan.style.width = '12px';
      iconSpan.style.height = '2px';

      if (isCollapsed) {
        const verticalLine = document.createElement('span');
        verticalLine.className = 'vertical-line';
        verticalLine.style.position = 'absolute';
        verticalLine.style.width = '2px';
        verticalLine.style.height = '12px';
        verticalLine.style.backgroundColor = 'rgba(112, 112, 112, 1)';
        verticalLine.style.left = '5px';
        verticalLine.style.top = '-5px';
        iconSpan.appendChild(verticalLine);
      }
    });
  }

  function init() {
    applyFacetState();

    // MutationObserver: re-apply state after Convermax re-renders
    var debounceTimer = null;
    const observer = new MutationObserver(function(mutations) {
      var needsUpdate = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && m.addedNodes.length > 0) {
          needsUpdate = true;
          break;
        }
        if (m.type === 'attributes' && m.attributeName === 'style') {
          needsUpdate = true;
          break;
        }
      }
      if (needsUpdate) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyFacetState, 30);
      }
    });

    const facetsContainer = document.querySelector('.cm_Facets, .cm_FacetPanel');
    if (facetsContainer) {
      observer.observe(facetsContainer, {
        attributes: true,
        attributeFilter: ['style'],
        subtree: true,
        childList: true
      });
    }

    // Capture-phase click handler to manage open/close state
    document.addEventListener('click', function(e) {
      const facetTitle = e.target.closest('.facettitle');
      if (!facetTitle) return;

      const holder = facetTitle.closest('.facetholder');
      if (!holder) return;

      // Skip mobile dialog — facets are always expanded there
      if (holder.closest('#cm_FacetDialog') || holder.closest('.cm_dialog')) return;

      const fieldId = getFacetFieldId(holder);
      if (!fieldId) return;

      // Toggle user open/close state
      if (openFacets.has(fieldId)) {
        openFacets.delete(fieldId);
        holder.classList.remove('cm-filter-open');
      } else {
        openFacets.add(fieldId);
        holder.classList.add('cm-filter-open');
      }

      // Prevent Convermax's own toggle from fighting our state
      e.stopPropagation();
      e.preventDefault();

      updateFilterIcons();
    }, true); // capture phase
  }

  function waitForConvermax() {
    const facetsSelector = '.cm_Facets, .cm_FacetPanel, .facetholder';

    if (document.querySelector(facetsSelector)) {
      init();
    } else {
      const loadObserver = new MutationObserver(function() {
        if (document.querySelector(facetsSelector)) {
          loadObserver.disconnect();
          init();
        }
      });

      loadObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForConvermax);
  } else {
    waitForConvermax();
  }
})();

// Vehicle Banner - Replace Collection Header
(function() {
  // CSS for the vehicle banner
  const style = document.createElement('style');
  style.textContent = `
    /* Banner container above products */
    .collection-banner-container {
      width: 100%;
      margin: 20px 0;
    }
    
    /* Default banner (no vehicle) */
    .default-collection-banner {
      padding: 12px 20px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    
    .default-collection-banner .banner-text {
      font-family: 'Inter', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: #000;
      margin: 0;
    }
    
    .default-collection-banner .collection-name {
      font-family: 'Inter', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      color: #000;
    }
    
    /* Vehicle banner (green) */
    .vehicle-banner-replacement {
      background-color: rgba(225, 255, 237, 1);
      padding: 12px 20px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      box-sizing: border-box;
      position: relative;
    }
    
    .vehicle-banner-replacement .check-icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }
    
    .vehicle-banner-replacement .banner-text {
      font-family: 'Inter', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: #000;
      margin: 0;
    }
    
    .vehicle-banner-replacement .vehicle-name {
      font-family: 'Inter', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
      text-transform: uppercase;
      color: #000;
    }
    
    .vehicle-banner-replacement .close-btn {
      background: none;
      border: none;
      color: #000;
      cursor: pointer;
      font-size: 24px;
      padding: 0;
      position: absolute;
      top: 8px;
      right: 16px;
      width: 24px;
      height: 24px;
      line-height: 1;
    }
    
    /* Mobile responsive styles */
    @media (max-width: 768px) {
      .collection-banner-container {
        margin: 15px 0;
      }
      
      .default-collection-banner,
      .vehicle-banner-replacement {
        padding: 10px 15px;
        flex-wrap: wrap;
      }
      
      .default-collection-banner .banner-text,
      .vehicle-banner-replacement .banner-text {
        font-size: 16px;
      }
      
      .default-collection-banner .collection-name,
      .vehicle-banner-replacement .vehicle-name {
        font-size: 16px;
      }
      
      .vehicle-banner-replacement .check-icon {
        width: 18px;
        height: 18px;
      }
      
      .vehicle-banner-replacement .close-btn {
        top: 6px;
        right: 10px;
        font-size: 20px;
        width: 20px;
        height: 20px;
      }
    }
    
    @media (max-width: 480px) {
      .default-collection-banner,
      .vehicle-banner-replacement {
        padding: 8px 12px;
      }
      
      .default-collection-banner .banner-text,
      .vehicle-banner-replacement .banner-text {
        font-size: 14px;
      }
      
      .default-collection-banner .collection-name,
      .vehicle-banner-replacement .vehicle-name {
        font-size: 14px;
      }
      
      .vehicle-banner-replacement .check-icon {
        width: 16px;
        height: 16px;
      }
    }
  `;
  document.head.appendChild(style);
  
  function getVehicleInfo() {
    try {
      // If the user explicitly cleared the vehicle, do not reuse stale storage.
      try {
        if (sessionStorage.getItem('cm_vehicle_cleared') === '1') {
          return null;
        }
      } catch(e) {}

      // Check URL parameters first
      const urlParams = new URLSearchParams(window.location.search);
      const year = urlParams.get('year');
      const make = urlParams.get('make');
      const model = urlParams.get('model');
      
      if (year && make && model) {
        return {
          year: year,
          make: decodeURIComponent(make).toUpperCase(),
          model: decodeURIComponent(model).toUpperCase()
        };
      }
      
      // [#429] Prefer the *current* YMM selection in the Convermax tabs.
      // This block used to sit BELOW the cm_vehicle lookup, which meant a stale
      // sessionStorage value written on a previous page won over the vehicle the
      // shopper had just picked -- the collection-page ribbon kept naming the old
      // vehicle while Convermax filtered by the new one. OEW and 4PLAY already
      // read the widget first; this brings Defiant in line with them.
      try {
        const root = document.querySelector('#cm-ymm-tabs');
        if (root) {
          const yearSel = root.querySelector('.cm_select_inner-select[aria-label="Year"]');
          const makeSel = root.querySelector('.cm_select_inner-select[aria-label="Make"]');
          const modelSel = root.querySelector('.cm_select_inner-select[aria-label="Model"]');

          const yearVal = yearSel && yearSel.value ? String(yearSel.value).trim() : '';
          const makeVal = makeSel && makeSel.value ? String(makeSel.value).trim() : '';
          const modelVal = modelSel && modelSel.value ? String(modelSel.value).trim() : '';

          const yearText = yearSel && yearSel.selectedOptions && yearSel.selectedOptions[0] ? String(yearSel.selectedOptions[0].textContent || '').trim() : '';
          const makeText = makeSel && makeSel.selectedOptions && makeSel.selectedOptions[0] ? String(makeSel.selectedOptions[0].textContent || '').trim() : '';
          const modelText = modelSel && modelSel.selectedOptions && modelSel.selectedOptions[0] ? String(modelSel.selectedOptions[0].textContent || '').trim() : '';

          const looksLikePlaceholder = (txt) => /^(year|make|model)\b/i.test(txt);

          if (!yearVal || !makeVal || !modelVal || looksLikePlaceholder(yearText) || looksLikePlaceholder(makeText) || looksLikePlaceholder(modelText)) {
            // Not fully selected yet, fall through to other sources.
            // NOTE: this deliberately falls through rather than returning null --
            // returning null here would blank the ribbon while Convermax hydrates.
          } else {
            // Keep sessionStorage in sync so other pages/components can rely on it.
            try {
              sessionStorage.setItem('cm_vehicle', JSON.stringify({ year: yearVal, make: makeVal, model: modelVal }));
              sessionStorage.removeItem('cm_vehicle_cleared');
            } catch(e) {}

            return {
              year: yearVal,
              make: makeVal.toUpperCase(),
              model: modelVal.toUpperCase()
            };
          }
        }
      } catch(e) {}

      // Next, fall back to any stored vehicle.
      const cmVehicle = sessionStorage.getItem('cm_vehicle');
      if (cmVehicle) {
        try {
          const vehicle = JSON.parse(cmVehicle);
          if (vehicle && vehicle.year && vehicle.make && vehicle.model) {
            return {
              year: vehicle.year,
              make: vehicle.make.toUpperCase(),
              model: vehicle.model.toUpperCase()
            };
          }
        } catch(e) {
        }
      }
      
      // Check garage badge
      const garageBadge = document.querySelector('#cm-garage .garage-size');
      if (garageBadge && garageBadge.textContent.trim() !== '0') {
        const dropdown = document.querySelector('#cm-garage .dropdown-content, #cm-garage .cm_dropdown-content');
        if (dropdown) {
          const items = dropdown.querySelectorAll('.garage-item, .cm_garage-item, [class*="vehicle"]');
          if (items.length > 0) {
            const firstItem = items[0];
            const text = firstItem.textContent || firstItem.innerText || '';
            const match = text.match(/(\d{4})\s+([^\s]+)\s+(.+)/);
            if (match) {
              return {
                year: match[1],
                make: match[2].toUpperCase(),
                model: match[3].trim().toUpperCase()
              };
            }
          }
        }
      }
      
      // Check Convermax API for active vehicle
      if (window.Convermax && window.Convermax.api && window.Convermax.api.getActiveVehicle) {
        try {
          const activeVehicle = window.Convermax.api.getActiveVehicle();
          if (activeVehicle && activeVehicle.year && activeVehicle.make && activeVehicle.model) {
            return {
              year: activeVehicle.year,
              make: activeVehicle.make.toUpperCase(),
              model: activeVehicle.model.toUpperCase()
            };
          }
        } catch(e) {
        }
      }
      
      // Check URL filters for vehicle selection
      const filters = urlParams.get('filter.p.m.oew.year');
      const makeFilter = urlParams.get('filter.p.m.oew.make');
      const modelFilter = urlParams.get('filter.p.m.oew.model');
      if (filters || makeFilter || modelFilter) {
        if (filters && makeFilter && modelFilter) {
          return {
            year: filters,
            make: makeFilter.toUpperCase(),
            model: modelFilter.toUpperCase()
          };
        }
      }
      

      const variantModel = localStorage.getItem('cm_variant-model');
      if (variantModel) {
        try {
          const modelData = JSON.parse(variantModel);
          if (Array.isArray(modelData) && modelData.length >= 3) {
            // Data structure: [{field: 'Year', term: '2024', value: '2024'}, {field: 'Make', ...}, {field: 'Model', ...}]
            const vehicleData = {};
            modelData.forEach(item => {
              if (!item) return;
              const field = (item.field || item.name || '').toString().toLowerCase();
              const value = (item.value || item.term || item.label || '').toString();
              if (!value) return;
              if (field === 'year') vehicleData.year = value;
              if (field === 'make') vehicleData.make = value;
              if (field === 'model') vehicleData.model = value;
            });
            if (vehicleData.year && vehicleData.make && vehicleData.model) {
              return {
                year: vehicleData.year,
                make: vehicleData.make.toUpperCase(),
                model: vehicleData.model.toUpperCase()
              };
            }
          }
        } catch(e) {
        }
      }
      
      for (let key in localStorage) {
        if (key.includes('convermax') || key.includes('cm_') || key.includes('CMVehicle')) {
          try {
            const data = JSON.parse(localStorage.getItem(key));
            
            // Detailed logging for specific keys
            if (key === 'cm_variant-garage' && Array.isArray(data) && data.length > 0) {
            } else {
            }
            
            if (data && data.year && data.make && data.model) {
              return {
                year: data.year,
                make: data.make.toUpperCase(),
                model: data.model.toUpperCase()
              };
            }
          } catch(e) {}
        }
      }
      
      return null;
    } catch(e) {
      return null;
    }
  }
  
  function updateCollectionHeader() {
    // Find the search header to insert banner before it
    let insertTarget = document.querySelector('.cm_SearchHeader');
    
    // If no search header, try products container
    if (!insertTarget) {
      insertTarget = document.querySelector('.cm-results-products, .cm_results-products, [class*="cm-results"], [class*="products-container"]');
    }
    
    if (!insertTarget) {
      return;
    }
    
    const vehicle = getVehicleInfo();
    
    // Get collection name
    const header = document.querySelector('h1.cm-collection-header__title, .cm-collection-header__title');
    let displayText = 'Shopping All Wheels';
    let collectionName = 'All Wheels';
    if (header) {
      const originalText = header.textContent.trim();
      collectionName = originalText.replace(/^Shopping\s+/i, '').trim();
      displayText = originalText.toLowerCase().startsWith('shopping') ? originalText : `Shopping ${collectionName}`;
    }
    
    if (vehicle) {
      // Remove default banner if exists
      const defaultBanner = document.querySelector('.default-collection-banner');
      if (defaultBanner) {
        defaultBanner.remove();
      }
      
      // Check if vehicle banner already exists to prevent duplicates
      const existingBanner = document.querySelector('.vehicle-banner-replacement');
      if (existingBanner) {
        try {
          const vehicleNameEl = existingBanner.querySelector('.vehicle-name');
          if (vehicleNameEl) {
            vehicleNameEl.textContent = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;
          }
        } catch(e) {}
        return;
      }
      
      // Insert green vehicle banner before products
      const bannerHTML = `<div class="collection-banner-container">
          <div class="vehicle-banner-replacement">
            <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM15.535 8.381C15.7145 8.19975 15.9566 8.09397 16.2115 8.08532C16.4665 8.07667 16.7152 8.1658 16.9066 8.33447C17.098 8.50313 17.2177 8.73858 17.2412 8.99262C17.2647 9.24666 17.1902 9.50008 17.033 9.701L16.95 9.795L11.364 15.382C11.1733 15.5726 10.9193 15.6866 10.6502 15.7023C10.381 15.7179 10.1155 15.6342 9.904 15.467L9.808 15.382L7.05 12.624C6.86875 12.4445 6.76297 12.2024 6.75432 11.9475C6.74567 11.6925 6.8348 11.4438 7.00347 11.2524C7.17213 11.061 7.40758 10.9413 7.66162 10.9178C7.91566 10.8943 8.16908 10.9688 8.37 11.126L8.464 11.21L10.586 13.331L15.536 8.381H15.535Z" fill="#00E65C"/>
            </svg>
            <p class="banner-text">
              Wheels that fit your <span class="vehicle-name">${vehicle.year} ${vehicle.make} ${vehicle.model}</span>
            </p>
            <button type="button" class="close-btn" onclick="
              sessionStorage.removeItem('cm_vehicle');
              localStorage.removeItem('cm_variant-model');
              localStorage.removeItem('cm_variant-garage');
              window.location.href = window.location.pathname;
            " aria-label="Close">×</button>
          </div>
        </div>`;
      
      insertTarget.insertAdjacentHTML('beforebegin', bannerHTML);
      
    } else {
      // Remove vehicle banner if exists
      const vehicleBanner = document.querySelector('.vehicle-banner-replacement');
      if (vehicleBanner) {
        const container = vehicleBanner.closest('.collection-banner-container');
        if (container) container.remove();
      }
      
      // Add default banner if it doesn't exist
      const existingDefaultBanner = document.querySelector('.default-collection-banner');
      if (!existingDefaultBanner) {
        const defaultBannerHTML = `<div class="collection-banner-container">
            <div class="default-collection-banner">
              <p class="banner-text">Shopping <span class="collection-name">${collectionName}</span></p>
            </div>
          </div>`;
        
        insertTarget.insertAdjacentHTML('beforebegin', defaultBannerHTML);
      }
    }
  }
  
  // Listen for Convermax vehicle changes
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cm_vehicle-widget_button__go')) {
      try { sessionStorage.removeItem('cm_vehicle_cleared'); } catch(e) {}
      setTimeout(updateCollectionHeader, 500);
      setTimeout(updateCollectionHeader, 1000);
    }
  });

  // If the user clicks CLEAR in the subheader widget, reset to default banner.
  document.addEventListener('click', function(e) {
    const clearBtn = e.target.closest('.cm_vehicle-widget_button__clear');
    if (!clearBtn) return;
    if (!clearBtn.closest || !clearBtn.closest('#cm-ymm-tabs')) return;

    try {
      sessionStorage.setItem('cm_vehicle_cleared', '1');
      sessionStorage.removeItem('cm_vehicle');
    } catch(e) {}

    // Convermax commonly persists this; remove it so it doesn't look like an active selection.
    try { localStorage.removeItem('cm_variant-model'); } catch(e) {}
    try { localStorage.removeItem('cm_variant-garage'); } catch(e) {}

    setTimeout(updateCollectionHeader, 0);
    setTimeout(updateCollectionHeader, 300);
  });

  // Realtime updates while selecting Year/Make/Model in the header/subheader widget
  document.addEventListener('change', function(e) {
    const t = e.target;
    if (!t || !t.matches) return;
    if (!t.matches('.cm_select_inner-select[aria-label="Year"], .cm_select_inner-select[aria-label="Make"], .cm_select_inner-select[aria-label="Model"]')) return;
    if (!t.closest('#cm-ymm-tabs')) return;
    setTimeout(updateCollectionHeader, 0);
  });

  // Convermax often re-renders the widget; observe it to keep banner in sync
  const attachYmmObserver = () => {
    const root = document.querySelector('#cm-ymm-tabs');
    if (!root || root.__garageBannerObserved) return;
    root.__garageBannerObserved = true;
    try {
      const mo = new MutationObserver(() => updateCollectionHeader());
      mo.observe(root, { childList: true, subtree: true, attributes: true });
    } catch(e) {}
  };
  attachYmmObserver();
  let ymmObsTry = 0;
  const ymmObsTimer = setInterval(() => {
    ymmObsTry++;
    attachYmmObserver();
    if (ymmObsTry >= 20) clearInterval(ymmObsTimer);
  }, 250);
  
  // Watch for DOM changes to catch dynamically loaded headers
  const headerObserver = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('.cm-collection-header__title, h1.cm-collection-header__title')) {
              setTimeout(updateCollectionHeader, 100);
              return;
            }
            if (node.querySelector && node.querySelector('.cm-collection-header__title, h1.cm-collection-header__title')) {
              setTimeout(updateCollectionHeader, 100);
              return;
            }
          }
        }
      }
    }
  });
  
  // Start observing
  if (document.body) {
    headerObserver.observe(document.body, { childList: true, subtree: true });
  }
  
  function initializeBanner() {
    updateCollectionHeader();
    setTimeout(updateCollectionHeader, 500);
    setTimeout(updateCollectionHeader, 1000);
    setTimeout(updateCollectionHeader, 2000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBanner);
  } else {
    initializeBanner();
  }
  
  setInterval(updateCollectionHeader, 3000);
})();


(function() {
  function updateSaleFilterLabel() {
    const saleFacet = document.querySelector('.cm_field-oew_on_sale');
    if (!saleFacet) return;
    
    const includedLabel = saleFacet.querySelector('.facetentrykey');
    if (includedLabel && includedLabel.textContent.trim() === 'Included') {
      includedLabel.textContent = 'Sale / Promotion';
    }
  }
  
  // Run on page load
  function init() {
    updateSaleFilterLabel();
    setTimeout(updateSaleFilterLabel, 500);
    setTimeout(updateSaleFilterLabel, 1000);
    setTimeout(updateSaleFilterLabel, 2000);
  }
  
  // Watch for Convermax filter changes
  const observer = new MutationObserver(function(mutations) {
    updateSaleFilterLabel();
  });
  
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function() {
  function updateTypeFilterLabel() {
    const typeFacet = document.querySelector('.cm_field-oew_shopify_product_classifier');
    if (!typeFacet) return;
    
    // Check if already processed
    if (typeFacet.hasAttribute('data-type-processed')) return;
    
    let kitDiv = null;
    let setDiv = null;
    
    // Find both divs and update label
    const facetDivs = typeFacet.querySelectorAll('.facetdiv');
    facetDivs.forEach(div => {
      const label = div.querySelector('.facetentrykey');
      if (!label) return;
      
      const text = label.textContent.trim();
      if (text === 'Kit/package') {
        label.textContent = 'Wheel & Tire Package';
        kitDiv = div;
      } else if (text === 'Set') {
        setDiv = div;
      }
    });
    
    // Reorder: Move Set before Wheel & Tire Package
    if (kitDiv && setDiv && kitDiv.parentNode === setDiv.parentNode) {
      const parent = kitDiv.parentNode;
      parent.insertBefore(setDiv, kitDiv);
      typeFacet.setAttribute('data-type-processed', 'true');
    }
  }
  
  // Run on page load
  function init() {
    updateTypeFilterLabel();
    setTimeout(updateTypeFilterLabel, 500);
    setTimeout(updateTypeFilterLabel, 1000);
    setTimeout(updateTypeFilterLabel, 2000);
  }
  
  // Watch for Convermax filter changes
  const observer = new MutationObserver(function(mutations) {
    updateTypeFilterLabel();
  });
  
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

